import type { ReactElement } from "react";
import { CmtsMyWorkspaceContainer } from "../../core/containers/domain/workspaceRouteContainers.js";
import type { CmtsHostRuntime } from "../../../app/appRuntime.js";

export function Component(props: { readonly runtime: CmtsHostRuntime }): ReactElement {
  return <CmtsMyWorkspaceContainer runtime={props.runtime} />;
}

export default Component;
